/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-25 16:18:41
 */
export const API = {
  /** ä¿®æ¹å¯ç  */
  updatePassword: `/cli/bus/client/change_password.do`,
};
